/**
 * @module UI/Utilities/Helpers
 * @desc Helpers helper funtions
 */

import { Utilities } from 'core';

/**
 * Return merge objects
 */
export const mergeObjects = (
  target: Utilities.PlainObject,
  source: { [x: string]: any; hasOwnProperty: (arg0: string) => any },
) => {
  const output = target;

  for (const key in source) {
    // eslint-disable-next-line no-prototype-builtins
    if (source.hasOwnProperty(key)) {
      if (typeof source[key] === 'object' && source[key] !== null) {
        if (output[key] && typeof output[key] === 'object') {
          // Se o target já tem um objeto na mesma chave, mescle os objetos
          output[key] = mergeObjects(output[key], source[key]);
        }
      } else {
        output[key] = source[key];
      }
    }
  }

  return output;
};
